export default function initializeComments() {
    let form = document.querySelector('#comment-form');

    if (form) {
        form.addEventListener('submit', function (e) {
            handleFormSubmit(e, form);
        });
    }
}

function validateForm(form) {
    let error = false;

    let languages = form.querySelector('.form__languages'),
        author = form.querySelector('.form__input[name="author"]'),
        email = form.querySelector('.form__input[name="email"]'),
        comment = form.querySelector('.form__textarea[name="comment"]');

    if (!isNotEmpty(author.value)) {
        error = true;
        author.closest('.form__element').querySelector('.form__tip').innerHTML = languages.dataset.empty;
    }

    if (!isNotEmpty(email.value)) {
        error = true;
        email.closest('.form__element').querySelector('.form__tip').innerHTML = languages.dataset.empty;
    } else if (!isCorrectEmail(email.value)) {
        error = true;
        email.closest('.form__element').querySelector('.form__tip').innerHTML = languages.dataset.badEmail;
    }

    if (!isNotEmpty(comment.value)) {
        error = true;
        comment.closest('.form__element').querySelector('.form__tip').innerHTML = languages.dataset.empty;
    }

    return !error;
}

function clearForm(form) {
    form.querySelectorAll('.form__input, .form__textarea').forEach(function (element) {
        element.value = '';
    });

    clearErrors(form);
}

function clearErrors(form) {
    form.querySelectorAll('.form__tip').forEach(function (element) {
        element.innerHTML = '';
    });
}

function isNotEmpty(value) {
    return value.length >= 1;
}

function isCorrectEmail(value) {
    let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

    return emailReg.test(value);
}

function handleFormSubmit(e, form) {
    e.preventDefault();

    let response = form.querySelector('.form__response-text'),
        languages = form.querySelector('.form__languages');

    form.classList.add('form--submitting');
    form.classList.remove('form--invalid');
    form.classList.remove('form--success');
    response.innerHTML = '';
    clearErrors(form);

    if (validateForm(form)) {
        const [postId, author, email, comment] = e.target.elements;

        const data = JSON.stringify({
            post: postId.value,
            author_name: author.value,
            author_email: email.value,
            content: comment.value,
        });

        fetch(window.location.origin + '/wp-json/wp/v2/comments', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: data,
        })
            .then((resp) => {
                if (resp.ok) {
                    form.classList.remove('form--submitting');
                    form.classList.add('form--success');
                    response.innerHTML = languages.dataset.success;
                    clearForm(form);
                } else {
                    return resp.json();
                }
            })
            .then((object) => {
                if (object && !object.id) {
                    form.classList.remove('form--submitting');
                    form.classList.add('form--invalid');
                    response.innerHTML = object.message;
                }
            })
            .catch(error => console.error('Error:', error));
    } else {
        setTimeout(function () {
                form.classList.remove('form--submitting');
                form.classList.add('form--invalid');
                response.innerHTML = languages.dataset.error;
            },
            100);
    }
}